// extracted by mini-css-extract-plugin
export default {"icon":"H4CX6rb76F7h2UR","left-direction":"huBR9bV8M05TtU0","right-direction":"wbd8DovS25qpl1t"};